export function moneyInputToNumber(input: string): number {
  const sanitized = input.replace(/\./g, '').replace(',', '.');
  return parseFloat(sanitized);
}
